/**
 * Auszeichnungs-Marker des Positions-Langtexts. Geteilt, weil hier zwei Seiten
 * dasselbe wissen müssen: der Editor zeigt die Codes in der Formatierungshilfe an,
 * das PDF wertet sie aus (`parseRich` in `apps/api/src/common/pdf-markdown.ts`).
 * Standen die Codes doppelt im Code, hätte eine neue Auszeichnung im PDF gewirkt,
 * ohne dass sie jemand in der Oberfläche findet — oder umgekehrt.
 *
 * Die Hex-Werte bleiben absichtlich in der API: welcher Magenta-Ton gedruckt wird,
 * ist eine Druck-Entscheidung und interessiert das Frontend nicht.
 */

/** Farbmarker `#<code>#…#<code>#` mit deutscher Bezeichnung für die Oberfläche. */
export const RICH_TEXT_COLORS: readonly { code: string; label: string }[] = [
  { code: 'm', label: 'magenta' },
  { code: 'r', label: 'rot' },
  { code: 'g', label: 'grün' },
  { code: 'b', label: 'blau' },
  { code: 'o', label: 'orange' },
];

/**
 * Vollständige Liste für die Formatierungshilfe im Editor — Schrift-Auszeichnung
 * zuerst, danach die Farben in derselben Reihenfolge wie oben.
 */
export const RICH_TEXT_HELP: readonly { code: string; label: string }[] = [
  { code: '**fett**', label: 'fett' },
  { code: '__unterstrichen__', label: 'unterstrichen' },
  ...RICH_TEXT_COLORS.map((color) => ({ code: `#${color.code}#…#${color.code}#`, label: color.label })),
];
